// Copyright (c) 2024 by Audere

import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";

export const getErrorText = (
  error?: FetchBaseQueryError | SerializedError
): string => {
  console.error(error);

  return error
    ? "status" in error
      ? typeof error.status === "number"
        ? `HTTP code ${error.status}`
        : `Fetch error: ${error.status}`
      : `Serialized error: ${error.message ?? "unknown"}`
    : "Undefined error type";
};
